import { render, staticRenderFns } from "./UIActionButton.vue?vue&type=template&id=7fc7dc99&scoped=true"
import script from "./UIActionButton.vue?vue&type=script&lang=js"
export * from "./UIActionButton.vue?vue&type=script&lang=js"
import style0 from "./UIActionButton.vue?vue&type=style&index=0&id=7fc7dc99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc7dc99",
  null
  
)

export default component.exports